<!--The content below is only a placeholder and can be replaced.-->
<!-- <div > -->

<app-nav-bar *ngIf="getJwt('')"></app-nav-bar>
<router-outlet></router-outlet>
<app-footer *ngIf="getJwt('footer')"></app-footer>
<!-- </div> -->
<!-- <div *ngIf="!(getJwt())">
        <router-outlet></router-outlet>
</div> -->
<div id="infoModal" class="modal fade" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="myModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title" id="myModalLabel">Advertencia</h1>
      </div>
      <div class="modal-body">
        <p style="font-size: large">Para que el aplicativo funcione correctamente por favor use el navegador <strong>Google Chrome</strong>.</p>
      </div>
    </div>
  </div>
</div>
